var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag){return _c('div',{staticClass:"tag"},[_vm._v("\n\t\t"+_vm._s(tag)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }